import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';

import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';

@Injectable({ providedIn: 'root' })
export class AmplifyConfigService {
  public loadConfig(): Promise<boolean> {
    return new Promise(resolve => {
      Amplify.configure({
        ...awsconfig,
        Analytics: {
          disabled: true
        }
      });
      cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

      resolve(true);
    });
  }
}
